import * as React from 'react';
import { HOME_PAGE, MY_PROFILE_PAGE } from 'constants/pages';
import { getProfileImageUrlOrPlaceholder } from 'utils/shared/user/getProfileImageUrlOrPlaceholder';
import { ButtonLink } from 'components/Button';
import Link from 'components/Link';
import NotificationIndicator from 'components/NotificationIndicator';
import CoachDropdown from './CoachNavDropdown';

interface Props {
  isCoach: boolean;
  profileImagePath?: string | null;
  shouldShowStartAction?: boolean;
  onOpenNotifications: () => void;
  onNavigate: (href: string) => void;
}

export default function UserActions({
  isCoach,
  profileImagePath,
  shouldShowStartAction,
  onOpenNotifications,
  onNavigate,
}: Props) {
  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <div className="flex h-full shrink-0 items-center">
        {!!shouldShowStartAction && (
          <ButtonLink
            href={HOME_PAGE}
            size="sm"
            variant="brand"
            isInline
            className="ml-4 mr-4 inline"
            onClick={(e) => {
              e.preventDefault();
              onNavigate(HOME_PAGE);
            }}
          >
            Get started
          </ButtonLink>
        )}
        <div className="flex flex-row items-center justify-center gap-6">
          <div className="items-right flex w-full gap-10 self-center py-2">
            <div className="my-auto flex w-full flex-1 shrink basis-0 items-center justify-between gap-10 self-stretch">
              <NotificationIndicator
                className="h-5 w-5 text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary"
                onClick={onOpenNotifications}
              />
            </div>
          </div>
          {/* Coaches keep the dropdown — it is their only nav route to settings and logout. */}
          {isCoach ? (
            <CoachDropdown />
          ) : (
            <Link
              href={MY_PROFILE_PAGE}
              className="block shrink-0 rounded-full"
              onClick={(e) => {
                e.preventDefault();
                onNavigate(MY_PROFILE_PAGE);
              }}
            >
              <img
                className="h-8 w-8 rounded-full object-cover"
                src={getProfileImageUrlOrPlaceholder({ path: profileImagePath })}
                alt="Profile"
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
